<div class="settingSidebar" [ngClass]="isOpenSidebar ? 'showSettingPanel' : ''">
 
 
</div>
